import { state } from '../state';
import type { VehicleData } from '../api/types';

export function updateTopbarStats(vehicles: VehicleData[]): void {
  let hc = 0, wc = 0, cc = 0;
  vehicles.forEach((v) => {
    if (v.healthStatus === 'healthy')       hc++;
    else if (v.healthStatus === 'warning')  wc++;
    else                                    cc++;
  });
  const total = vehicles.length;
  const pct   = (n: number) => (total > 0 ? Math.round((n / total) * 100) + '%' : '0%');

  (document.getElementById('totalCount')    as HTMLElement).textContent = String(total);
  (document.getElementById('healthyCount')  as HTMLElement).textContent = String(hc);
  (document.getElementById('warningCount')  as HTMLElement).textContent = String(wc);
  (document.getElementById('criticalCount') as HTMLElement).textContent = String(cc);
  (document.getElementById('healthyPct')    as HTMLElement).textContent = pct(hc);
  (document.getElementById('warningPct')    as HTMLElement).textContent = pct(wc);
  (document.getElementById('criticalPct')   as HTMLElement).textContent = pct(cc);
  const subtitle = document.getElementById('phSubtitle');
  if (subtitle) subtitle.textContent = `${total} Assets · Updated just now`;
}

export function updateLastRefreshDisplay(): void {
  if (!state.lastRefreshTime) return;
  const diff = Math.floor((Date.now() - state.lastRefreshTime.getTime()) / 1000);
  let t: string;
  if (diff < 10)       t = 'Just now';
  else if (diff < 60)  t = `${diff}s ago`;
  else                 t = `${Math.floor(diff / 60)}m ago`;
  const el = document.getElementById('lastRefresh');
  if (el) el.textContent = t;
}

export function setDatabaseLabel(database: string): void {
  const el = document.getElementById('databaseName');
  if (el) el.textContent = database;

  // Every page header carries its own database label; they all get filled here.
  ['phDbLabel', 'idlingDbLabel', 'safetyDbLabel', 'wdDbLabel', 'rdDbLabel',
   'laDbLabel', 'auDbLabel', 'zaDbLabel'].forEach(id => {
    const node = document.getElementById(id);
    if (node) node.textContent = database;
  });
}
